// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-message-box__headerbtn {\r\n  right: 24px;\n}\n.upload-form {\r\n  padding-bottom: 0 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
